import { Timestamps } from '../types/shared'
import { SpecialityOption } from './speciality-option.model'
import { Staff } from './staff.model'

export type Schedule = Timestamps & {
  _id: string
  consultationReason: string
  createdBy: Pick<Staff, '_id' | 'accountType' | 'status' | 'userInfo' | 'establishment'>
  duration: number
  exceptions: ScheduleException[]
  recurrenceRule?: {
    daysOfWeek: number[]
    datesOfMonth: number[]
    monthsOfYear: number[]
    recurrenceType: ScheduleRecurrenceType
    separationCount: number
  }
  startDate: string // Date
  endDate?: string // Date
  startTime: number
  endTime: number
  parentId?: string
}

export type ScheduleAvailability = {
  busySlots: Slot[]
  workingHours: WorkingHours[]
  timeZone?: string
}

export type ScheduleException = Omit<Schedule, 'createdBy' | 'exceptions' | 'parentId'> & {
  isRescheduled: boolean
  isCancelled: boolean
  scheduleId: string
}

export enum ScheduleRecurrenceType {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

export type Slot = {
  owner: string
  start: string
  end: string
}

export type WorkingHours = {
  days: Array<number>
  duration?: number
  kind?: string
  startTime: number
  endTime: number
}
